const DEFAULT_STATE = {
  shallContentShowOverlay: false,
  homePageURL: "/",
  userName: "",
  userEmail: "",
  snackBar: {
    show: false,
    text: "",
    color: "success",
    timeout: 2000,
  },
  dialog: {
    key: null,
    show: false,
    type: "simple", // or "confirm"
    title: "Title",
    text: "Content",
    code: "",
    component: null,
    componentProps: [],
    useActionButtons: true,
    width: 1200,
    minWidth: 400,
    maxWidth: 1600,
    callbackFunction: () => {}, // function to be called when user click OK
  },
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getHomePageURL: (state) => state.homePageURL,
    getUserName: (state) => state.userName,
    getUserEmail: (state) => state.userEmail,
    getSnackBar: (state) => state.snackBar,
    getDialog: (state) => state.dialog,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    TOGGLE_CONTENT_OVERLAY(state, value) {
      state.shallContentShowOverlay =
        value !== undefined ? value : !state.shallContentShowOverlay;
    },
    setHomePageURL(state, value) {
      state.homePageURL = value;
    },
    setUserName(state, value) {
      state.userName = value;
    },
    setUserEmail(state, value) {
      state.userEmail = value;
    },
    setSnackBar(state, value) {
      state.snackBar = value;
    },
    setDialog(state, value) {
      state.dialog = value;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    setHomePageURL({ commit }, value) {
      commit("setHomePageURL", value);
    },
    setUserName({ commit }, value) {
      commit("setUserName", value);
    },
    setUserEmail({ commit }, value) {
      commit("setUserEmail", value);
    },
    setSnackBar({ commit }, value) {
      commit("setSnackBar", value);
    },
    setDialog({ commit }, value) {
      commit("setDialog", value);
    },
  },
};
